import ProductCardWidget1 from './Card1';

export { ProductCardWidget1 };
